import { CSSObject } from '@chakra-ui/react';
import { TBodyTextProps } from '../types';

export const BodyText = ({ heading }: TBodyTextProps): CSSObject => ({
  '&&': {
    fontSize: heading ? 'sm' : 'xs',
    fontWeight: heading ? 'semibold' : 'normal',
    color: 'white',
    lineHeight: '1.3',
  },
});

export const RadioText: CSSObject = {
  '&&': {
    fontSize: 'xs',
    mb: '2',
    fontWeight: 'medium',
    color: 'white',
  },
};

export const DepositLimitContainer: CSSObject = {
  mt: '4',
  border: '1px dashed',
  borderColor: 'whiteAlpha.500',
  borderRadius: 'base',
  p: '4',
  '.chakra-input__group': {
    borderRadius: 'md',
    background: 'rgba(0, 0, 0, 0.36)',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.10), 0px 1px 5px 0px rgba(0, 0, 0, 0.15) inset',
  },
  '.chakra-input__left-addon': {
    bg: 'transparent',
    fontSize: 'xs',
    fontWeight: 'semibold',
    border: 'none',
    h: '9',
    color: 'gamma.400',
    pl: '4',
    pr: '2',
    pt: 'px',
  },
  '.chakra-select': {
    background: 'rgba(0, 0, 0, 0.36)',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.10), 0px 1px 5px 0px rgba(0, 0, 0, 0.15) inset',
    fontSize: 'xs',
    color: 'white',
    border: 'none',
    option: {
      color: 'black',
    },
  },
  '.chakra-select__icon-wrapper': {
    color: 'gamma.400',
  },
  '#limitAmount-input': {
    fontSize: 'xs',
    fontWeight: 'medium',
    bg: 'transparent',
    color: 'white',
    border: 'none',
    h: '9',
    px: '0',
    '&&:hover, &&:focus': {
      bg: 'alpha.600',
      border: 'none',
    },
  },
};

export const FlexHeaderWrapper: CSSObject = {
  color: 'gray.500',
  fontSize: 'md',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 'semibold',
  mb: ['4', null, '5'],
  pt: [null, null, '1'],
  gap: '2',
};

export const ButtonSubmit: CSSObject = {
  borderRadius: 'md',
  fontWeight: 'normal',
  color: 'alpha.700',
  textShadow: '0px 1px 0px rgba(255, 255, 255, 0.35)',
  background:
    'var(--gradients-gradient-gamma-300-500, linear-gradient(180deg, #FFD562 0%, #DEA913 100%))',
  boxShadow:
    '0px 3px 5px 0px rgba(0, 0, 0, 0.30), 0px 0px 0px 1px rgba(255, 255, 255, 0.15) inset',
};

export const RadioLimitChoice: CSSObject = {
  bg: 'white',
  border: 'none',
  mb: '2',
  '&[data-checked]': {
    bg: 'alpha.400',
    borderWidth: '4px',
    borderStyle: 'solid',
    borderColor: 'white',
    color: 'alpha.400',
  },
  '&[data-checked]:hover': {
    bg: 'alpha.400',
    borderWidth: '4px',
    borderStyle: 'solid',
    borderColor: 'white',
    color: 'alpha.400',
  },
};
